import { render, staticRenderFns } from "./text-meta.vue?vue&type=template&id=31b85f93&"
import script from "./text-meta.vue?vue&type=script&lang=js&"
export * from "./text-meta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b85f93')) {
      api.createRecord('31b85f93', component.options)
    } else {
      api.reload('31b85f93', component.options)
    }
    module.hot.accept("./text-meta.vue?vue&type=template&id=31b85f93&", function () {
      api.rerender('31b85f93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/text-meta.vue"
export default component.exports